import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { projectUrl: String }

  goToShow(e) {
    if (e.target.closest("a, button")) return; 
    window.location.href = this.projectUrlValue
  }

  stop(event) {
    event.stopPropagation()
  }
}
